"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigningContext = void 0;
const react_1 = require("react");
exports.SigningContext = react_1.createContext(undefined);
//# sourceMappingURL=signing-context.js.map